<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="icCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('gwsbbttjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._a"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/岗位、社保补贴统计表--导入.xls" download="岗位、社保补贴统计表--导入.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
          :data="tableData"
          border
          max-height="550"
          @selection-change="handleSelectionChange"
          style="width: 99.9%">
        <el-table-column
            type="selection"
            width="40">
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
        </el-table-column>
        <el-table-column label="社会保险补贴金额（元）" align="center">
          <el-table-column label="养老" align="center">
            <el-table-column
                show-overflow-tooltip
                v-for="(item,index) in baseInfo2"
                :key="index"
                :prop="item.key"
                :label="item.value"
                align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="医疗" align="center">
            <el-table-column
                show-overflow-tooltip
                v-for="(item,index) in baseInfo3"
                :key="index"
                :prop="item.key"
                :label="item.value"
                align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="失业" align="center">
            <el-table-column
                show-overflow-tooltip
                v-for="(item,index) in baseInfo4"
                :key="index"
                :prop="item.key"
                :label="item.value"
                align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
          :data="tableData1"
          border
          max-height="550"
          @selection-change="handleSelectionChange"
          style="width: 99.9%">
        <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo1"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
        </el-table-column>
        <el-table-column
            label="社会保险补贴人数（人）"
            align="center">
          <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo5"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="社会保险补贴金额（元）"
            align="center">
          <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo6"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
            show-overflow-tooltip
            prop="allowanceTotalFee"
            label="社会保险补贴金额（元）"
            align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
        title="岗位、社保补贴统计表"
        :visible.sync="centerDialogVisible"
        @close="close"
        :modal="false"
        width="1400px"
        :close-on-click-modal="false"
        center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item   prop="name" label="姓名：" :rules="{required: true, message: '请输入姓名', trigger: 'blur'}">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item   prop="idCard" label="身份证号：" :rules="[{required: true, message: '请输入身份证号', trigger: 'blur'},
                                {min: 18, max: 18, message: '长度为18个字符', trigger: 'blur'}]">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="phone" label="联系方式：" :rules="{required: true, message: '请输入电话', trigger: 'blur'}">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位补贴申报年份：">
                          <el-date-picker
                              v-model="editForm.applyYear"
                              type="year"
                              format="yyyy"
                              value-format="yyyy"
                              style="width:193px;"
                              placeholder="选择年">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="岗位补贴金额(元)：">
                          <el-input style="width:193px;"
                                v-model="editForm.jobAllowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item label="统计日期：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.time"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">社会保险补贴金额（元）</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item prop="pensionStartMonth" label="养老开始月份：">
                          <el-date-picker
                              v-model="editForm.pensionStartMonth"
                              type="month"
                              value-format="yyyy-MM"
                              format="yyyy-MM"
                              style="width:193px;"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="pensionEndMonth" label="养老结束月份：">
                          <el-date-picker
                              style="width:193px;"
                              format="yyyy-MM"
                              value-format="yyyy-MM"
                              v-model="editForm.pensionEndMonth"
                              type="month"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="pensionAllowanceFee" label="补贴金额(元)：">
                          <el-input style="width:193px;"
                                v-model="editForm.pensionAllowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item prop="medicalStartMonth" label="医疗开始月份：">
                          <el-date-picker
                              v-model="editForm.medicalStartMonth"
                              value-format="yyyy-MM"
                              format="yyyy-MM"
                              type="month"
                              style="width:193px;"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="medicalEndMonth" label="医疗结束月份：">
                          <el-date-picker
                              v-model="editForm.medicalEndMonth"
                              format="yyyy-MM"
                              value-format="yyyy-MM"
                              style="width:193px;"
                              type="month"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="medicalAllowanceFee" label="补贴金额(元)：">
                          <el-input style="width:193px;"
                                v-model="editForm.medicalAllowanceFee"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="unemploymentStartMonth" label="失业开始月份：">
                          <el-date-picker
                              v-model="editForm.unemploymentStartMonth"
                              value-format="yyyy-MM"
                              format="yyyy-MM"
                              type="month"
                              style="width:193px;"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="unemploymentEndMonth" label="失业结束月份：">
                          <el-date-picker
                              style="width:193px;"
                              v-model="editForm.unemploymentEndMonth"
                              format="yyyy-MM"
                              value-format='yyyy-MM'
                              type="month"
                              placeholder="选择月">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="unemploymentAllowanceFee" label="补贴金额(元)：">
                          <el-input style="width:193px;"
                                v-model="editForm.unemploymentAllowanceFee"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return {
      isCreate: false,
      out:false,
      type:'22',
      centerDialogVisible: false,
      api:'/user/socialAllowance',
      form: {},
      tableData: [],
      tableData1:[],
      selectRow: [],
      rules: {
        pensionStartMonth: [
          {required: true, message: '请输入开始月份', trigger: 'blur'}
        ],
        pensionEndMonth: [
          {required: true, message: '请输入结束月份', trigger: 'blur'}
        ],
        pensionAllowanceFee: [
          {required: true, message: '请输入补贴金额', trigger: 'blur'}
        ],
        medicalStartMonth: [
          {required: true, message: '请输入开始月份', trigger: 'blur'}
        ],
        medicalEndMonth: [
          {required: true, message: '请输入结束月份', trigger: 'blur'}
        ],
        medicalAllowanceFee: [
          {required: true, message: '请输入补贴金额', trigger: 'blur'}
        ],
        unemploymentStartMonth: [
          {required: true, message: '请输入开始月份', trigger: 'blur'}
        ],
        unemploymentEndMonth: [
          {required: true, message: '请输入结束月份', trigger: 'blur'}
        ],
        unemploymentAllowanceFee: [
          {required: true, message: '请输入补贴金额', trigger: 'blur'}
        ],
      },
      baseInfo: [
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'name', value: '姓名'},
        {key: 'idCard', value: '身份证'},
        {key: 'phone', value: '联系方式'},
        {key: 'applyYear', value: '岗位补贴申报年份'},
        {key: 'jobAllowanceFee', value: '岗位补贴金额（元）'},
        {key:'time',value:'统计时间'},
      ],
      baseInfo1: [
        {key: 'areaName', value: '行政区划名称'},
        {key: 'jobAllowanceCount', value: '岗位补贴人数'},
        {key: 'jobAllowanceTotalFee', value: '培训补贴金额(元)'},
      ],
      baseInfo5: [
        {key: 'socialPersonCount', value: '小计(人次)'},
        {key: 'socialCount', value: '小计(人数)'},
        {key: 'pensionAllowanceCount', value: '养老'},
        {key: 'medicalAllowanceCount', value: '医疗'},
        {key:'unemploymentAllowanceCount',value:'失业'},
      ],
      baseInfo6: [
        {key: 'socialAllowanceTotalFee', value: '小计'},
        {key: 'pensionAllowanceTotalFee', value: '养老'},
        {key: 'medicalAllowanceTotalFee', value: '医疗'},
        {key:'unemploymentAllowanceTotalFee',value:'失业'},
      ],
      baseInfo2: [
        {key: 'pensionStartMonth', value: '开始月份'},
        {key: 'pensionEndMonth', value: '结束月份'},
        {key: 'pensionAllowanceFee', value: '补贴金额'},
      ],
      baseInfo3: [
        {key: 'medicalStartMonth', value: '开始月份'},
        {key: 'medicalEndMonth', value: '结束月份'},
        {key: 'medicalAllowanceFee', value: '补贴金额'},
      ],
      baseInfo4: [
        {key: 'unemploymentStartMonth', value: '开始月份'},
        {key: 'unemploymentEndMonth', value: '结束月份'},
        {key: 'unemploymentAllowanceFee', value: '补贴金额'},
      ],
    }
  },
  created() {
    this.isShowBtn("SocialAllowance")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods: {
    //选择行数据
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //提交请求
    submit() {
      let newForm ={}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.time = new Date(newForm.time).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    }
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.edit {
  padding-left: 15px;
}
</style>